import React from 'react'
import {Carousel, Col} from 'react-bootstrap'
import {TrendingUp, NotificationsActive, Receipt} from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import {COLORS} from "../../Common/constants/colors";

const AuthCarousel = () => {
    const {t} = useTranslation();
    const slideStyle: React.CSSProperties = {
        backgroundColor: COLORS.PRIMARY_COLOR,
        padding: "50px",
        minHeight:  "90%"
    };

    const iconStyle: React.CSSProperties = {
        fontSize: "75px",
        color: "#ffffff",
        marginBottom: "10px",
    };
    const titleStyle: React.CSSProperties = {
        fontSize: "32px",
        color: "#ffffff",
    }

    const contentStyle: React.CSSProperties = {
        textAlign: "center" as const, // Ensures correct type assignment
        padding: "50px",
    };
    return (
        <React.Fragment>
            <Col lg={6}>
                        <Carousel indicators={true} controls={false}>
                            <Carousel.Item>
                                <div style={slideStyle}>
                                    <div style={contentStyle}>
                                        <TrendingUp style={iconStyle}/>
                                        <h3 style={titleStyle}>{t('Login.carousel.slide1.title')}</h3>
                                        <p className="fs-15 text-white-75 mt-2 mb-0">{t('Login.carousel.slide1.subtitle')}</p>
                                    </div>
                                </div>


                            </Carousel.Item>

                            <Carousel.Item>
                                <div style={slideStyle}>
                                    <div style={contentStyle}>
                                        <NotificationsActive style={iconStyle}/>
                                        <h3 style={titleStyle}>{t('Login.carousel.slide2.title')}</h3>
                                        <p className="fs-15 text-white-75 mt-2 mb-0">{t('Login.carousel.slide2.subtitle')}</p>
                                    </div>
                                </div>

                            </Carousel.Item>

                            <Carousel.Item>
                                <div style={slideStyle}>
                                    <div style={contentStyle}>
                                        <Receipt style={iconStyle}/>
                                        <h3 style={titleStyle}>{t('Login.carousel.slide3.title')}</h3>
                                        <p className="fs-15 text-white-75 mt-2 mb-0">{t('Login.carousel.slide3.subtitle')}</p>
                                    </div>
                                </div>

                            </Carousel.Item>
                        </Carousel>
            </Col>
        </React.Fragment>
    )
}

export default AuthCarousel
